var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"alert alert-warning"},[_vm._v("You are in the administration section")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }